import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { FormattedDate } from 'components/intl'
import { Modal, ModalCTA } from 'containers/misc'
import { Section, Span, Title } from 'components/layout'
import { InputDate, Select } from 'components/fields'
import { Button, ButtonGroup, List, ListItem, Module } from 'components/misc'
import { modal } from 'redux/modules/app'
import { apiCommon, apiLeaders } from 'helpers/decorators/api'
import { publicAwardUnitsDropdownSelector } from 'redux/selectors/organizations'
import { form } from 'helpers/decorators'
import { historyValidate } from 'models/leaders'

@apiLeaders({
  updateDetail: true,
  detailReadParams: 'AWARD_LEADERSHIP_HISTORY,TRAININGS',
  personReadParams: 'ADDRESS,AWARD_LEADER_PROFILE,AWARD_LEADERSHIP_HISTORY'
})
@apiCommon()
@connect(
  state => ({
    dropdownPublicAwardUnits: publicAwardUnitsDropdownSelector(state)
  }),
  { modal }
)
@form({
  form: 'add-leader-history-record',
  validate: historyValidate
})
class LeaderHistory extends Component {
  static propTypes = {
    leaderId: PropTypes.number,
    first: PropTypes.bool,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    modal: PropTypes.func.isRequired,
    addHistoryRecord: PropTypes.func.isRequired,
    updateHistoryRecord: PropTypes.func.isRequired,
    deleteHistoryRecord: PropTypes.func.isRequired,
    fetchPublicAwardUnits: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    fetchCountriesWithStructure: PropTypes.func.isRequired,
    values: PropTypes.object,
    data: PropTypes.object,
    list: PropTypes.array,
    dropdownPublicAwardUnits: PropTypes.array,
    common: PropTypes.object.isRequired
  }

  state = {
    isEditing: false,
    isDeleting: false,
    recordId: null,
    isLoading: false
  }

  handleAddHistoryRecord = () => {
    this.setState({ isLoading: true })
    this.props
      .fetchCountriesWithStructure()
      .then(() => {
        this.props.modal('modal-leader-history-record')
        this.props.initialize({})
        this.setState({ isLoading: false })
      })
      .catch(() => {
        this.setState({ isLoading: false })
      })
  }

  handleEditHistoryRecord = record => {
    this.setState({ isLoading: true })
    this.props
      .fetchCountriesWithStructure()
      .then(() => {
        this.props
          .fetchPublicAwardUnits({
            countryId: record.awardUnit.country.id
          })
          .then(() => {
            this.props.modal('modal-leader-history-record')
            this.props.initialize({
              recordId: record.id,
              awardUnit: { id: record.awardUnit.id },
              country: { id: record.awardUnit.country.id },
              startDate: record.startDate,
              endDate: record.endDate
            })
            this.setState({
              isEditing: true,
              recordId: record.id,
              isLoading: false
            })
          })
          .catch(() => {
            this.setState({ isLoading: false })
          })
      })
      .catch(() => {
        this.setState({ isLoading: false })
      })
  }

  handleDeleteHistoryRecord = () => {
    this.setState({
      isDeleting: true
    })
  }

  handleOnClose = () => {
    this.setState({
      isEditing: false,
      isDeleting: false,
      recordId: null
    })
  }

  handleCancelDelete = () => {
    this.setState({
      isDeleting: false
    })
  }

  render () {
    const {
      handleSubmit,
      common,
      dropdownPublicAwardUnits,
      values,
      addHistoryRecord,
      updateHistoryRecord,
      deleteHistoryRecord,
      data,
      list,
      first,
      pristine,
      submitting,
      leaderId
    } = this.props
    const { isEditing, isDeleting, recordId, isLoading } = this.state
    const recordsList = get(data, 'person.awardLeadershipHistory') || list || []

    const buttonDefinition = [
      {
        'order': 1,
        'secondary': true,
        'onClick': this.handleAddHistoryRecord,
        'iconAction': null,
        'isActionLoading': false,
        'intlKeyAction': 'button.add_history_record',
        'action': 'Add history record'
      }
    ]

    return (
      <div>
        <Module
          title="History"
          intlKey="moduleTitle.history"
          buttonDefinition={buttonDefinition}
          primary
          first={first}
        >
          <Section loading={isLoading} inBox>
            <List custom>
              {recordsList && (
                <div>
                  {recordsList.map(item => (
                    <ListItem
                      key={item.id}
                      onClick={() => this.handleEditHistoryRecord(item)}
                    >
                      <div className="row">
                        <div className="col-xs-6">
                          {get(item, 'awardUnit.name')}
                        </div>
                        <div className="col-xs-6 text--right">
                          {item.startDate && (
                            <FormattedDate value={item.startDate} spaceAfter />
                          )}{' '}
                          -{' '}
                          {item.endDate && (
                            <FormattedDate value={item.endDate} />
                          )}
                        </div>
                      </div>
                    </ListItem>
                  ))}
                  {recordsList.length === 0 && (
                    <Span intlKey="global.no_records" muted>
                      No records
                    </Span>
                  )}
                </div>
              )}
            </List>
          </Section>
        </Module>
        <Modal
          id="modal-leader-history-record"
          action="Add"
          intlKey="button.add"
          onClose={this.handleOnClose}
          customActions
          enableOverflow
        >
          <form
            onSubmit={handleSubmit(fields => {
              return isEditing
                ? updateHistoryRecord(leaderId, fields)
                : addHistoryRecord(leaderId, fields)
            })}
          >
            <div className="row">
              <div className="col-xs-6">
                <Select
                  label="Country"
                  intlKey="label.country"
                  name="country.id"
                  options={common.countries.list}
                  loading={common.countries.loading}
                  searchable
                  onChange={({ value } = {}) => {
                    this.props.change('country.id', value)
                    this.props.fetchPublicAwardUnits({
                      countryId: value
                    })
                  }}
                />
              </div>
              <div className="col-xs-6">
                <Select
                  label="Award Unit"
                  intlKey="label.award_unit"
                  name="awardUnit.id"
                  options={dropdownPublicAwardUnits}
                  searchable
                  disabled={!get(values, 'country.id') && !isEditing}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-6">
                <InputDate
                  label="Start date"
                  intlKey="label.start_date"
                  name="startDate"
                />
              </div>
              <div className="col-xs-6">
                <InputDate
                  label="End date"
                  intlKey="label.end_date"
                  name="endDate"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-xs-6">
                <ButtonGroup>
                  <Button
                    type="button"
                    intlKey="button.close"
                    onClick={() => this.props.modal(null)}
                    secondary
                  >
                    Close
                  </Button>
                  {isEditing && (
                    <Button
                      type="button"
                      intlKey="button.delete"
                      onClick={() => this.handleDeleteHistoryRecord(recordId)}
                      negative
                    >
                      Delete
                    </Button>
                  )}
                </ButtonGroup>
              </div>
              <div className="col-xs-6 text--right">
                {!isEditing ? (
                  <Button
                    intlKey="button.add"
                    disabled={pristine}
                    isLoading={submitting}
                  >
                    Add
                  </Button>
                ) : (
                  <Button intlKey="button.save" isLoading={submitting}>
                    Save
                  </Button>
                )}
              </div>
            </div>
          </form>
          {isDeleting && (
            <ModalCTA>
              <Title
                h2
                className="text--center"
                intlKey="moduleTitle.would_you_like_to_remove_leader_training"
              >
                Would you like to delete Award Leaders's training?
              </Title>
              <div className="row">
                <div className="col-xs-6">
                  <Button
                    type="button"
                    onClick={this.handleCancelDelete}
                    secondary
                    intlKey="button.close"
                  >
                    Close
                  </Button>
                </div>
                <div className="col-xs-6 text--right">
                  <Button
                    type="button"
                    negative
                    intlKey="button.confirm"
                    onClick={() => deleteHistoryRecord(leaderId, recordId)}
                  >
                    Confirm
                  </Button>
                </div>
              </div>
            </ModalCTA>
          )}
        </Modal>
      </div>
    )
  }
}

export default LeaderHistory
